module.exports = __webpack_public_path__ + "img/stock6.5095f193.png";